import ErrorIcon from '@mui/icons-material/Error';
import {
	Button,
	DialogActions,
	DialogContent,
	DialogTitle,
	Dialog as MuiDialog,
	Stack,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';

const dialogActionsStyles = {
	display: 'flex',
	flexFlow: 'row nowrap',
	justifyContent: 'center',
	backgroundColor: '#F7F7F7',
	gap: 1,
	px: 2,
	pb: 2,
};

const mobileHeaderStyling = {
	paddingTop: 0,
	paddingBottom: '0.5rem',
};

export default function ChangeVisitReasonModal({
	open,
	onProceed,
	onCancel,
}: Readonly<{ open: boolean; onProceed: () => void; onCancel: () => void }>) {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<MuiDialog open={open} aria-labelledby="change-visit-reason-title" data-test-id="change-rfv-modal">
			<DialogTitle id="change-visit-reason-title" sx={isMobile ? mobileHeaderStyling : {}}>
				<Stack alignItems="center" p={3} sx={isMobile ? { pb: '1rem' } : {}}>
					<ErrorIcon fontSize="large" sx={{ color: 'text.interactive' }} />
				</Stack>
				<Typography
					variant={isMobile ? 'header4' : 'header3'}
					data-test-id="change-rfv-modal-heading"
					textAlign="center"
				>
					Are you sure?
				</Typography>
			</DialogTitle>
			<DialogContent sx={{ textAlign: 'center' }}>
				<Typography
					variant={isMobile ? 'bodyMediumBook' : 'bodyLargeBook'}
					data-test-id="change-rfv-modal-body"
				>
					Our availability is designed to ensure pets are seen in order of need. If you change your reason for
					visit, your selected time may not be available. Do you want to proceed?
				</Typography>
			</DialogContent>
			<DialogActions sx={dialogActionsStyles}>
				<Button variant="tertiaryDefault" size="M" onClick={onCancel} data-test-id="change-rfv-cancel-button">
					Cancel
				</Button>
				<Button variant="primaryDefault" size="M" onClick={onProceed} data-test-id="change-rfv-proceed-button">
					Proceed
				</Button>
			</DialogActions>
		</MuiDialog>
	);
}
